/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Channelallusers2Inputs */

const en_channelallusers2 = /** @type {(inputs: Channelallusers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All users`)
};

const de_channelallusers2 = /** @type {(inputs: Channelallusers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Nutzer`)
};

/**
* | output |
* | --- |
* | "All users" |
*
* @param {Channelallusers2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const channelallusers2 = /** @type {((inputs?: Channelallusers2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Channelallusers2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_channelallusers2(inputs)
	return de_channelallusers2(inputs)
});
export { channelallusers2 as "channelAllUsers" }